import React, { useState } from 'react';
import { Alert, Button, Space, Typography } from 'antd';
import { CloseOutlined, DownloadOutlined, MobileOutlined } from '@ant-design/icons';
import { useMediaQuery } from 'react-responsive';
import { usePwaInstall } from '../../pwa/usePwaInstall';
import IosInstallGuideModal from './IosInstallGuideModal';
import AndroidInstallModal from './AndroidInstallModal';
import './PwaInstallBanner.css';

/**
 * Banner + modais de instalação PWA (Android prompt / guia iOS).
 */
const PwaInstallBanner = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [installing, setInstalling] = useState(false);
  const {
    showBanner,
    canPromptInstall,
    isIosSafari,
    promptInstall,
    dismissInstall,
    iosGuideOpen,
    openIosGuide,
    closeIosGuide,
    androidModalOpen,
    closeAndroidModal,
  } = usePwaInstall();

  const handleInstall = async () => {
    setInstalling(true);
    try {
      await promptInstall();
      closeAndroidModal();
    } finally {
      setInstalling(false);
    }
  };

  const handleDismissAndroid = () => {
    dismissInstall();
    closeAndroidModal();
  };

  if (!isMobile) {
    // Desktop: nunca mostrar banner/modal de instalar PWA
    return null;
  }

  return (
    <>
      {showBanner && (
        <Alert
          className="pwa-install-banner"
          type="info"
          showIcon
          icon={isIosSafari ? <MobileOutlined /> : <DownloadOutlined />}
          message={
            <div className="pwa-install-banner__row">
              <div className="pwa-install-banner__text">
                {isIosSafari ? (
                  <Typography.Text>
                    Instale o app: Compartilhar → Adicionar à Tela de Início
                  </Typography.Text>
                ) : (
                  <Typography.Text>
                    Instale o Saldo Ativo no celular
                  </Typography.Text>
                )}
              </div>
              <Space size="small" wrap>
                {canPromptInstall && (
                  <Button type="primary" size="small" loading={installing} onClick={handleInstall}>
                    Instalar
                  </Button>
                )}
                {isIosSafari && (
                  <Button type="primary" size="small" onClick={openIosGuide}>
                    Como instalar
                  </Button>
                )}
                <Button
                  type="text"
                  size="small"
                  icon={<CloseOutlined />}
                  aria-label="Dispensar"
                  onClick={dismissInstall}
                />
              </Space>
            </div>
          }
        />
      )}
      <IosInstallGuideModal open={iosGuideOpen} onClose={closeIosGuide} />
      <AndroidInstallModal
        open={androidModalOpen && isMobile}
        onInstall={handleInstall}
        onDismiss={handleDismissAndroid}
        loading={installing}
      />
    </>
  );
};

export default PwaInstallBanner;
